export const getUpgradeFare = (direction, searchDirection, isInbound, targetClasses, tariffCodes) => {
  if (!direction || !searchDirection) {
    return null;
  }

  const journey = searchDirection.journeys?.find((jrn) =>
    jrn.fares?.find(
      (fare) =>
        targetClasses.includes(fare.classOfService?.code) &&
        fare.legs?.find(
          (leg) =>
            leg.products?.some((product) => tariffCodes.includes(product.code)) &&
            leg.trainNumber === direction.trainNumber &&
            leg.destination.uic === direction.destination.uic &&
            leg.origin.uic === direction.origin.uic
        )
    )
  );

  if (!journey) {
    return null;
  }

  const fare = journey.fares.find((fr) => targetClasses.includes(fr.classOfService?.code) && fr.bookingItems.length > 0);

  if (!fare) {
    return null;
  }

  return {
    ...fare,
    direction: isInbound ? 'inbound' : 'outbound'
  };
};
